/**
 * <custom-homepage-carousel> — prev/next scrolling for the "Trending Now" track
 * in sections/custom-homepage.liquid.
 */
class CustomHomepageCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-ch-track]');
    if (!this.track) return;

    this.addEventListener('click', this.handleClick);
    this.track.addEventListener('scroll', this.updateArrows, { passive: true });
    this.updateArrows();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.track?.removeEventListener('scroll', this.updateArrows);
  }

  handleClick = (event) => {
    const button = event.target.closest('[data-ch-scroll]');
    if (!button) return;

    const direction = button.dataset.chScroll === 'prev' ? -1 : 1;
    const distance = Math.min(600, this.track.clientWidth * 0.88);
    this.track.scrollBy({ left: direction * distance, behavior: 'smooth' });
  };

  updateArrows = () => {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    const atStart = scrollLeft <= 1;
    const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;

    this.querySelector('[data-ch-scroll="prev"]')?.toggleAttribute('disabled', atStart);
    this.querySelector('[data-ch-scroll="next"]')?.toggleAttribute('disabled', atEnd);
  };
}

if (!customElements.get('custom-homepage-carousel')) {
  customElements.define('custom-homepage-carousel', CustomHomepageCarousel);
}
